'use client';
import { IoIosArrowDown } from 'react-icons/io';
import { Accordion } from 'rsuite';
import styles from './accordion.module.scss';
type Props = {
  title: string;
  children?: React.ReactNode;
};

const Header = (props: { title: any }) => {
  const { title } = props;
  return (
    <div className={styles.headerContent}>
      <h4>{title}</h4>
    </div>
  );
};

const CustomAccordion = ({ title, children }: Props) => {
  return (
    <div>
      {' '}
      <Accordion defaultActiveKey={1} classPrefix={styles.accord}>
        <Accordion.Panel
          header={<Header title={title} />}
          caretAs={IoIosArrowDown}
        >
          {children}
        </Accordion.Panel>
      </Accordion>
    </div>
  );
};

export default CustomAccordion;
